import React, {Component} from 'react';
import {DocType, getDocTypeLangKey} from "../definitions/DocType";
import {Accordion} from "react-accessible-accordion";
import SsqDocumentsAccordionItem from "./SsqDocumentsAccordionItem";
import {
  emptyEducationCountOfEachDocTypeRequest,
  emptyICountSsqDataByDocType,
  ICountOfEachDocTypeRequest,
  ICountsOfEachDocType,
  IGetSsqDataByPageRequest,
  ISsqDataDocument,
  SsqDataRepository
} from "../repositories/SsqDataRepository";
import {CategoryRepository} from "../repositories/category/CategoryRepository";
import {LanguageService} from "../language/LanguageService";
import CategoryStore from "../repositories/category/CategoryStore";
import {ISrchParam, SsqDataColumnTitles, SubTabButtons, SubTabTableArea} from "./ProductPage";
import {ErrorpageWrap, ViewmoreArea} from "../style/CommonStyledComponents";
import styled from "styled-components";
import {PERIOD_TYPE, SORT_TYPE} from "communitypage/common/CommunityFilter";
import {isEqual} from "lodash-es";
import {IfLoginInfo} from "models/IfLoginInfo";
import ToastPopup from "productpage/ToastPopup";
import {SsqImages} from "images/SsqImages";

interface Props {
  selectedCategoryId: number;
  languageService: LanguageService;
  categoryRepository: CategoryRepository;
  ssqDataRepository: SsqDataRepository;
  categoryStore: CategoryStore;
  getTranslation: Function;
  loadAllCategories: () => void;
  srchParam: ISrchParam;
  loginInfo?: IfLoginInfo;
  resetFilter?: Function;
  preSortType?: string;
}


interface State {
  selectedDocType: string;
  ssqDataDocuments: ISsqDataDocument[];
  ssqDataVersion: string;
  ssqDataDocumentsCounts: ICountsOfEachDocType;
  pageNum: number;
  seq: number;
  toastType: string;
  isMounted: boolean;
}

class ProductTrainingTabPanel extends Component<Props, State> {
  private readonly NO_DATA = "NO_DATA";
  private readonly PAGE_NUM_UNIT = 20;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedDocType: DocType.EDUCATION_VIDEO,
      ssqDataDocuments: [],
      ssqDataVersion: "",
      ssqDataDocumentsCounts: emptyICountSsqDataByDocType,
      pageNum: 0,
      seq: 0,
      toastType: '',
      isMounted: false,
    };
  }

  async componentDidMount() {
    const {selectedCategoryId} = this.props;
    await this.getSsqDataDocuments(Number(selectedCategoryId));
    await this.getSsqDataDocumentsCounts(Number(selectedCategoryId));

    this.setState({pageNum: 0});

    this.setState({
      isMounted: true,
    });
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const selectedCategoryId = this.props.selectedCategoryId;

    if ((prevProps.selectedCategoryId !== selectedCategoryId) || !isEqual(prevProps.srchParam, this.props.srchParam)) {
      await this.setState({pageNum: 0});
      await this.getSsqDataDocuments(Number(selectedCategoryId));
      await this.getSsqDataDocumentsCounts(Number(selectedCategoryId));

    }

    if (prevState.selectedDocType != this.state.selectedDocType) {
      await this.getSsqDataDocuments(Number(selectedCategoryId));
      this.setState({pageNum: 0});
    }

    if (prevState.pageNum != this.state.pageNum && this.state.pageNum !== 0) {
      await this.getSsqDataDocuments(Number(selectedCategoryId), true);
    }

    if (prevProps.preSortType !== this.props.preSortType) {
      await this.setState({pageNum: 0});
      await this.getSsqDataDocuments(Number(selectedCategoryId));
    }
  }

  getDefaultSelectedTabForEducationTab(docCounts: ICountsOfEachDocType): string {
    return this.state.selectedDocType;

    if (docCounts.educationVideoCount > 0)
      return DocType.EDUCATION_VIDEO;
    else if (docCounts.educationNoteCount > 0)
      return DocType.EDUCATION_NOTE;
    //else return this.state.selectedDocType;
  }

  async getSsqDataDocuments(categoryId: number, pageChanged: boolean = false) {
    if (this.state.selectedDocType !== this.NO_DATA) {
      let getSsqDataByPageRequest: IGetSsqDataByPageRequest = {
        ...emptyEducationCountOfEachDocTypeRequest,
        pageNum: this.state.pageNum,
        categoryId: categoryId,
        docTypes: [this.state.selectedDocType],
        exposeSiteLanguage: this.props.languageService.getLanguage(),
        sortType: this.props.srchParam.sortType === SORT_TYPE.RECENT ? 0 : this.props.srchParam.sortType === SORT_TYPE.UPDATE ? 1 : 2,
        periodType: this.props.srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 :
          this.props.srchParam.periodType === PERIOD_TYPE.WEEK ? 1 :
            this.props.srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 :
              this.props.srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
        tagType: this.props.srchParam.tagType,
        keyword: this.props.srchParam.keyword,
        userId: this.props.loginInfo.userId,
      };

      let ssqDataDocuments = await this.props.ssqDataRepository.getSsqDataByPage(getSsqDataByPageRequest);
      console.log("test ::: " + ssqDataDocuments);
      if (this.state.pageNum > 0 && pageChanged) {
        this.setState({ssqDataDocuments: [...this.state.ssqDataDocuments, ...ssqDataDocuments]});
      } else {
        this.setState({ssqDataDocuments});
      }
    } else {
      this.setState({ssqDataDocuments: []});
    }
  }

  async getSsqDataDocumentsCounts(categoryId: number) {
    let countOfEachDocTypeRequest: ICountOfEachDocTypeRequest = {
      ...emptyEducationCountOfEachDocTypeRequest,
      categoryId: categoryId,
      exposeSiteLanguage: this.props.languageService.getLanguage(),
      sortType: this.props.srchParam.sortType === SORT_TYPE.RECENT ? 0 : this.props.srchParam.sortType === SORT_TYPE.UPDATE ? 1 : 2,
      periodType: this.props.srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 :
        this.props.srchParam.periodType === PERIOD_TYPE.WEEK ? 1 :
          this.props.srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 :
            this.props.srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
      tagType: this.props.srchParam.tagType,
      keyword: this.props.srchParam.keyword,
      userId: this.props.loginInfo.userId,
    };

    let ssqDataDocumentsCounts =
      await this.props.ssqDataRepository.getCountsOfEachDocType(countOfEachDocTypeRequest);

    this.setState({
      selectedDocType: this.getDefaultSelectedTabForEducationTab(ssqDataDocumentsCounts),
      ssqDataDocumentsCounts
    });
  }

  isMoreDocumentsOnNextPage(documentCount: number) {
    return documentCount > this.PAGE_NUM_UNIT * (this.state.pageNum + 1);
  }

  isRenderViewMoreEducationTab(docType: string) {
    if (docType === DocType.EDUCATION_VIDEO)
      return this.isMoreDocumentsOnNextPage(this.state.ssqDataDocumentsCounts.educationVideoCount);
    else if (docType === DocType.EDUCATION_NOTE)
      return this.isMoreDocumentsOnNextPage(this.state.ssqDataDocumentsCounts.educationNoteCount);
    else if (docType === DocType.EDUCATION_INTERNAL)
      return this.isMoreDocumentsOnNextPage(this.state.ssqDataDocumentsCounts.educationInternalCount);
  }

  countDocTypeWithSsqDataDocumentAll(docType: string): number | undefined {
    if (docType === DocType.EDUCATION_VIDEO)
      return this.state.ssqDataDocumentsCounts.educationVideoCount;
    else if (docType === DocType.EDUCATION_NOTE)
      return this.state.ssqDataDocumentsCounts.educationNoteCount;
    else if (docType === DocType.EDUCATION_INTERNAL)
      return this.state.ssqDataDocumentsCounts.educationInternalCount;
    else
      return 0;
  }

  getPageCount() {
    return this.PAGE_NUM_UNIT * (this.state.pageNum + 1);
  }

  getTotalCount() {
    return this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType);
  }

  renderNoDocumentPageReset() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage"}>
        <img alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{this.props.getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{this.props.getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>
        {
          !isEqual(this.props.srchParam, {
            sortType: '',
            periodType: '',
            tagType: [],
            categoryId: 0,
            keyword: '',
          }) &&
          <button className="error-button" onClick={() => this.props.resetFilter()}>
            {this.props.getTranslation("I18N_NO_DOCUMENT_RESET")}
          </button>
        }
      </div>
    </ErrorpageWrap>;
  }

  renderNoDocumentPage() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage"}>
        <img alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{this.props.getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{this.props.getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>
      </div>
    </ErrorpageWrap>;
  }


  selectDocTypeCountNoDocumentPage() {
    if ((this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0 && this.getTabCnt() !== 0 ||
      this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0) && this.props.srchParam.keyword !== "")
      return this.renderNoDocumentPageReset();

    if (this.props.srchParam.keyword == "" && (this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0 && this.getTabCnt() !== 0 ||
      this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0))
      return this.renderNoDocumentPage();
  }

  renderDocumentTable() {
    return <>
      <ProductTablePadding>
        <SsqDataColumnTitles>
          <div className={"accordion-col-doc-num"}>{"No."}</div>
          <div className={"accordion-col-doc-title"}>{this.props.getTranslation("I18N_DOC_COL_EDUCATION_NAME")}</div>
          <div className={"accordion-col-doc-bookmark"}>{this.props.getTranslation("I18N_DOC_COL_BOOKMARK")}</div>
          <div className={"accordion-col-doc-share"}>{this.props.getTranslation("I18N_DOC_COL_SHARE")}</div>
          {/*<div className={"accordion-col-description"}>{this.props.getTranslation("I18N_DOC_COL_DESCRIPTION")}</div>*/}
          <div className={"accordion-col-doc-language"}>{this.props.getTranslation("I18N_DOC_COL_LANG")}</div>
          {/*<div className={"accordion-col-files"}>{this.props.getTranslation("I18N_DOC_COL_EDUCATION_VERSION")}</div>*/}
          <div className={"accordion-col-update-time"}>{this.props.getTranslation("I18N_DOC_COL_UPDATE_TIME")}</div>
          <div className={"accordion-col-click-count"}>{this.props.getTranslation("I18N_DOC_COL_VIEWS")}</div>
          <div className={"accordion-col-more"}></div>
        </SsqDataColumnTitles>
        <AccordionWrapper>
          <Accordion allowZeroExpanded>
            {this.state.ssqDataDocuments.map((document: ISsqDataDocument, index) => (
              <div key={'' + index + ':' + document.id}>
                <SsqDocumentsAccordionItem
                  postNum={index + 1}
                  document={document}
                  ssqDataRepository={this.props.ssqDataRepository}
                  languageService={this.props.languageService}
                  categoryStore={this.props.categoryStore}
                  loadAllCategories={this.props.loadAllCategories}
                  openToast={(type) => {
                    this.setState({toastType: type, seq: this.state.seq + 1});
                  }}
                />
              </div>
            ))}
          </Accordion>
        </AccordionWrapper>
        <ToastPopup languageService={this.props.languageService} loginInfo={this.props.loginInfo}
          seq={this.state.seq + 1}
          type={this.state.toastType}
        ></ToastPopup>
        {this.state.isMounted && this.selectDocTypeCountNoDocumentPage()}
      </ProductTablePadding>
    </>;
  }

  getTabCnt() {
    let cnt = 0;
    if (this.state.ssqDataDocumentsCounts.educationVideoCount > 0) cnt = cnt + 1;
    if (this.state.ssqDataDocumentsCounts.educationNoteCount > 0) cnt = cnt + 1;
    if (this.state.ssqDataDocumentsCounts.educationInternalCount > 0) cnt = cnt + 1;
    return cnt;
  };

  renderSubTabButton(docType: string) {
    const count = this.countDocTypeWithSsqDataDocumentAll(docType) || 0;

    if (this.state.isMounted && this.state.selectedDocType === docType && count != 0)
      return <div className={`tab-button selected`}
        onClick={() => {
          this.setState({
            selectedDocType: docType,
            pageNum: 0
          });
        }}>
        {this.props.getTranslation(getDocTypeLangKey(docType))} <span>{count}</span>
      </div>;

    return count > 0 && <div className={`tab-button ${this.state.selectedDocType === docType ? "selected" : ""}`}
      onClick={() => {
        this.setState({
          selectedDocType: docType,
          pageNum: 0
        });
      }}>
      {this.props.getTranslation(getDocTypeLangKey(docType))} <span>{count}</span>
    </div>;
  }

  render() {
    return (
      <div>
        <SubTabButtons>
          {this.renderSubTabButton(DocType.EDUCATION_VIDEO)}
          {this.renderSubTabButton(DocType.EDUCATION_NOTE)}
          {this.renderSubTabButton(DocType.EDUCATION_INTERNAL)}
        </SubTabButtons>
        {this.state.selectedDocType != this.NO_DATA
          &&
          <SubTabTableArea>
            {this.renderDocumentTable()}
            {this.isRenderViewMoreEducationTab(this.state.selectedDocType) && <ViewmoreArea className="view-more-area">
              <div className="view-more-list-box">
                <div className={"ViewmoreBtn"}>
                  <button className={"view-more-button"} onClick={() => {
                    this.setState({pageNum: this.state.pageNum + 1});
                  }}>
                    {this.props.getTranslation("I18N_DOC_VIEW_MORE")}
                  </button>
                </div>
                <div className={"ViewmoreNum"}>
                  <span className={"page-count"}>{this.getPageCount()}</span>
                  <span>{this.getTotalCount()}</span>
                </div>
              </div>
            </ViewmoreArea>
            }
          </SubTabTableArea>
        }
      </div>
    );
  }
}

export default ProductTrainingTabPanel;


const AccordionWrapper = styled.div`
  width: 100%;

  .accordion {
    width: 100%;
    color: #2A2C2F;
  }

  .accordion > div:nth-child(even) {
    background: #F7F8FB;
  }
`;

export const ProductTablePadding = styled.div`
  padding: 0 3rem;

  @media screen and (max-width: 764px) {
    padding: 0;
  }
`;
